// components/WhitepaperCard.js
import React from "react";

const WhitepaperCard = () => {
  return (
    <div className="bg-[#1a1a2e] rounded-2xl shadow-md p-6 mt-8 text-center">
      <h2 className="text-xl font-semibold text-white mb-3">📄 MediCoin Whitepaper</h2>
      <p className="text-gray-300 mb-4">
        Learn how MediCoin powers the future of decentralized healthcare, staking,
        burning, and smart tokenomics.
      </p>
      <a
        href="/assets/MediCoin-Whitepaper.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block bg-gradient-to-r from-purple-600 to-indigo-500 text-white font-semibold py-2 px-5 rounded-full hover:scale-105 transition-transform duration-300"
      >
        Download Whitepaper
      </a>
    </div>
  );
};

export default WhitepaperCard;
